import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api-client';
import { ArrowLeft, CheckCircle } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await api.forgotPassword(email);
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 pt-20">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="text-emerald-500 font-mono font-bold text-xl inline-block mb-6">
            <span className="text-cyan-400">{'>'}</span>_ClawStinger
          </Link>
          <h1 data-testid="forgot-title" className="text-2xl font-bold text-white font-mono mb-2">Reset your password</h1>
          <p className="text-sm text-zinc-500">We'll send you a reset link</p>
        </div>

        <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-8">
          {sent ? (
            <div data-testid="forgot-success" className="text-center py-4">
              <CheckCircle size={40} className="text-emerald-400 mx-auto mb-4" />
              <p className="text-white font-mono mb-2">Check your email</p>
              <p className="text-sm text-zinc-500">We sent a reset link to <span className="text-zinc-300">{email}</span></p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-xs font-mono text-zinc-500 mb-1.5">Email</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-[#111] border border-zinc-800 text-white rounded-sm px-4 py-2.5 text-sm font-mono focus:border-emerald-500/50 focus:ring-1 focus:ring-emerald-500/50 outline-none transition-all placeholder-zinc-600" placeholder="alex@company.com" />
              </div>
              <button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm py-3 hover:bg-emerald-400 transition-all click-scale shadow-[0_0_15px_rgba(16,185,129,0.3)] disabled:opacity-50">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}
        </div>

        <Link to="/signin" data-testid="forgot-back-link" className="flex items-center justify-center gap-2 text-sm text-zinc-500 hover:text-emerald-400 mt-6 font-mono transition-colors">
          <ArrowLeft size={14} /> Back to Sign In
        </Link>
      </div>
    </div>
  );
}
